module.exports = __webpack_public_path__ + "media/images/main_events/2024/thu-2024-icons-a5de5aad16edbe435d947c2ab607e04d.svg";